
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discussion",
      function () {
        return require("private-next-pages/discussion.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discussion"])
      });
    }
  